import { render, staticRenderFns } from "./fileLightFlag.vue?vue&type=template&id=04f682c1&scoped=true"
import script from "./fileLightFlag.vue?vue&type=script&lang=js"
export * from "./fileLightFlag.vue?vue&type=script&lang=js"
import style0 from "./fileLightFlag.vue?vue&type=style&index=0&id=04f682c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f682c1",
  null
  
)

export default component.exports